import { FC } from "react";
import st from './chartCircle.module.scss';
import cn from "classnames";

interface ChartCircleProps {
    color: string
    text: string
    textClassName?: string
}

export const ChartCircle: FC<ChartCircleProps> = (props) => {
    const {
        textClassName = '',
        color,
        text
    } = props;

    return (
        <>
            <div className={st['circle']} style={{ backgroundColor: color }} />
            <span className={cn(st['text'], textClassName)}>{text}</span>
        </>
    )
}